import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isDirty, isValid } from 'redux-form';

import { Main } from 'Containers/';
import { AERIES_MAPPINGS_FORM_NAME } from 'Common/FormEnum';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';
import { AeriesMapConfig } from 'Common/Constants/SISIntegration';
import { getGradesAction } from 'State/grades/actions';
import { getSitesAction } from 'State/sites/actions';

import { AeriesMappingStepForm } from './AeriesMappingForm';
import * as actions from '../../state/actions';
import * as selectors from '../../state/selectors';

class AeriesMappingStepContainer extends Component {
  static stepInfo = {
    icon: 'map',
    title: 'Map',
    description: 'Configure Aeries field mappings',
  };

  state = { hasBeenMappedPreviously: false };

  areAllFieldsMapped = (fieldData) => {
    for (const field of Object.keys(AeriesMapConfig)) {
      if (fieldData[field] == null) {
        return false;
      }
    }
    return true;
  };

  componentDidMount() {
    const {
      getMappings,
      getSitesAction,
      getGradesAction,
      getLanguages,
    } = this.props;
    getSitesAction();
    getGradesAction();
    getLanguages();
    getMappings();
  }

  componentDidUpdate(prevProps) {
    const {
      setMappingsSaveSuccessful,
      saveSuccessful,
      clearMappingsErrors,
      getMappings,
      setStepCompleted,
      isMappingsDirty,
      isMappingValid,
      stepCompleted,
      resetPreview,
      data,
    } = this.props;

    const { hasBeenMappedPreviously } = this.state;

    if (
      errorToast(this.props, prevProps, 'getError') ||
      errorToast(this.props, prevProps, 'writeError')
    ) {
      clearMappingsErrors();
    }

    if (!prevProps.saveSuccessful && saveSuccessful) {
      createToast(toastType.success, 'Success', 'Mappings Saved Successfully');
      getMappings();
      setMappingsSaveSuccessful(false);
      setStepCompleted(true);
      resetPreview();
    } else if (stepCompleted && isMappingsDirty) {
      setStepCompleted(false);
    }

    if (!prevProps.data && data) {
      if (this.areAllFieldsMapped(data)) {
        setStepCompleted(true);
        this.setState({ hasBeenMappedPreviously: true });
      }
    }

    if (
      isMappingValid &&
      !isMappingsDirty &&
      (prevProps.isMappingsDirty || !prevProps.isMappingValid) &&
      hasBeenMappedPreviously
    ) {
      setStepCompleted(true);
    }
  }

  mainProps = () => {
    const {
      loading,
      goToNextStep,
      goToPreviousStep,
      stepCompleted,
      isMappingsDirty,
    } = this.props;
    return {
      toolbox: {
        formName: AERIES_MAPPINGS_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: loading,
          disabled: loading,
        },
        backButtonProps: {
          shown: true,
          disabled: loading || isMappingsDirty,
          callback: goToPreviousStep,
        },
        rightButtons: [
          {
            content: 'Next',
            disabled: loading || !stepCompleted || isMappingsDirty,
            loading: loading,
            onClick: goToNextStep,
          },
        ],

        shown: true,
      },
    };
  };

  handleSubmit = (formValues) => {
    const { saveMappings } = this.props;
    saveMappings(formValues);
  };

  render() {
    const {
      data,
      loading,
      gradeOptions,
      siteOptions,
      languageOptions,
    } = this.props;

    return (
      <Main {...this.mainProps()}>
        <AeriesMappingStepForm
          data={data}
          onSubmit={this.handleSubmit}
          loading={loading}
          gradeOptions={gradeOptions}
          siteOptions={siteOptions}
          languageOptions={languageOptions}
          initialValues={{ ...data }}
        />
      </Main>
    );
  }
}

const mapDispatchToProps = {
  ...actions,
  getSitesAction,
  getGradesAction,
};

const mapStateToProps = (state) => {
  const mapping = selectors.getMapping(state);
  return {
    data: mapping.data,
    getError: mapping.errors.getError,
    writeError: mapping.errors.writeError,
    loading: mapping.loading,
    saveSuccessful: mapping.saveSuccessful,
    gradeOptions: selectors.getGradeOptions(state),
    siteOptions: selectors.getSiteOptions(state),
    languageOptions: selectors.getLanguageOptions(state),
    isMappingsDirty: isDirty(AERIES_MAPPINGS_FORM_NAME)(state),
    isMappingValid: isValid(AERIES_MAPPINGS_FORM_NAME)(state),
  };
};

export const AeriesMappingStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(AeriesMappingStepContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesMappingStep/AeriesMappingStep.js